const block = require('./block');
const EntryService = require('../services/EntryService').default;
const entryUpdate = require('./contentful/entry-update');
const getEntry = require('./contentful/entry-get');
const getSpace = require('./contentful/get-space');
const transformer = require('./transformers/model');
const linkResolve = require('./contentful/link-resolve');
const entryResolve = require('./contentful/entry-resolve');
const processError = require('./contentful/error-process');
const update = require('immutability-helper');

let entryService = null;

const gettingEntryService = () => {
  if (!entryService) {
    entryService = getSpace().then((space) => {
      return new EntryService(space, transformer);
    });
  }

  return entryService;
};

module.exports = {
  getById(...parameters) {
    return gettingEntryService().then((service) => service.getById(...parameters));
  },

  publishWithBlocks(model, depth) {
    const descriptionIdsToPublish = model.description.reduce((ids, md) => {
      if (!md.published || md.updated) {
        ids.push(md.id);
      }

      return ids;
    }, []);

    if (!descriptionIdsToPublish.length) {
      return gettingEntryService().then((service) => service.publish(model.id, depth));
    }

    return block.publishBlocks(descriptionIdsToPublish).then(() => {
      return gettingEntryService().then((service) => service.publish(model.id, depth));
    });
  },

  create(...parameters) {
    return gettingEntryService().then((service) => service.create('model', ...parameters));
  },

  publish(...parameters) {
    return gettingEntryService().then((service) => service.publish(...parameters));
  },

  unpublish(...parameters) {
    return gettingEntryService().then((service) => service.unpublish(...parameters));
  },

  archive(...parameters) {
    return gettingEntryService().then((service) => service.archive(...parameters));
  },

  unarchive(...parameters) {
    return gettingEntryService().then((service) => service.unarchive(...parameters));
  },

  initializeCustom(...parameters) {
    return gettingEntryService().then((service) => service.initializeCustom('model', ...parameters));
  },

  save(model, depth = 0) {
    return getSpace().then((space) => {
      return getEntry(space, model.id).then((entry) => {
        const data = entry.toPlainObject();
        let currentDescriptionLinks = [];

        if (data.fields.description && data.fields.description['nb-NO']) {
          currentDescriptionLinks = data.fields.description['nb-NO'];
        }

        return block.saveBlockArray(currentDescriptionLinks, model.description, false).then((newDescription) => {
          const newModel = update(model, {
            description: {
              $set: newDescription
            }
          });

          const data = transformer.internalToContentful(newModel);
          return entryUpdate(entry, data);
        }).then((entry) => {
          const data = entry.toPlainObject();
          return linkResolve(space, data, depth);
        }).then((data) => {
          return transformer.contentfulToInternal(data);
        });
      });
    });
  },

  modelsByMake(makeId, depth = 0, deprecated, fieldsToResolve) {
    return getSpace().then((space) => {
      return space.getEntries({
        'content_type': 'model',
        'fields.make.sys.id': makeId,
        'order': '-sys.updatedAt'
      }).catch(
        processError
      ).then((response) => {
        const data = response.toPlainObject();

        if (fieldsToResolve) {
          return entryResolve(space, data, depth, fieldsToResolve);
        }

        return linkResolve(space, data, depth);
      }).then((data) => {
        return data.items.map(transformer.contentfulToInternal);
      });
    });
  }
};
